import React from 'react';
import PropTypes from 'prop-types';
import { Divider, Grid } from 'semantic-ui-react';

const GridDivider = ({ columnWidth = 16 }) => (
  <Grid.Row style={{ paddingBottom: 0 }}>
    <Grid.Column width={columnWidth}>
      <Divider />
    </Grid.Column>
  </Grid.Row>
);

GridDivider.propTypes = {
  columnWidth: PropTypes.number,
};

export default GridDivider;



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/Basic/UCBGridDivider.jsx